<template>
  <div class="overflow-x-auto">
    <table class="w-full border border-gray-200 rounded-lg overflow-hidden">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Datum</th>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Beginn</th>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Ende</th>
          <th class="px-4 py-3 text-right text-sm font-semibold text-gray-700">Stunden</th>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Einsatzort</th>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Einsatzstelle</th>
          <th class="px-4 py-3 text-left text-sm font-semibold text-gray-700">Mitarbeiter</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="rows.length === 0">
          <td colspan="7" class="px-4 py-6 text-sm text-gray-500 text-center">Keine Aufträge vorhanden.</td>
        </tr>
        <tr v-for="(row, index) in rows" :key="index" class="border-b border-gray-200">
          <td class="px-4 py-2 text-sm">{{ formatDate(row.datum) }}</td>
          <td class="px-4 py-2 text-sm">{{ row.von || '-' }}</td>
          <td class="px-4 py-2 text-sm">{{ row.bis || '-' }}</td>
          <td class="px-4 py-2 text-sm text-right">{{ formatHours(row.stunden) }}</td>
          <td class="px-4 py-2 text-sm">{{ row.einsatzort || '-' }}</td>
          <td class="px-4 py-2 text-sm">{{ row.einsatzstelle || '-' }}</td>
          <td class="px-4 py-2 text-sm">{{ row.mitarbeiter || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InvoiceBeiblattTable',
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('de-DE');
    },
    formatHours(hours) {
      if (hours === null || hours === undefined) return '-';
      return hours.toLocaleString('de-DE');
    }
  }
};
</script>
